<template>
  <div class="container">
    <h1>隐私政策</h1>
    <div class="update-info">
      <p>更新日期：<strong>2025年10月15日</strong></p>
      <p>生效日期：<strong>2025年10月1日</strong></p>
    </div>

    <p>
      欢迎您使用<strong>禽舍环控APP</strong>！禽舍环控APP是由郑州森迈光电科技有限公司（以下简称“我们”）提供的移动端APP应用，我们深知个人信息对您的重要性，并庄严承诺保护使用我们的产品和服务（以下统称“服务”）之用户（以下统称“用户”或“您”）的个人信息及隐私安全。本隐私政策旨在帮助您了解我们如何收集、使用、存储、共享和保护您的个人信息，以及您如何行使您的个人信息相关权利。
    </p>

    <p>
      <strong
        >请您在使用我们的服务前，仔细阅读并充分理解本隐私政策的全部内容。一旦您开始使用我们的服务，即表示您已充分理解并同意我们按照本政策处理您的个人信息。</strong
      >
    </p>

    <h2>一、我们如何收集和使用您的个人信息</h2>
    <p>
      我们根据合法、正当、必要的原则，仅为了向您提供服务和实现本政策下述明目的收集您的个人信息：
    </p>
    <ul>
      <li>
        <strong>账户信息：</strong
        >当您注册和登录账户时，我们会收集您的手机号码用于验证身份及提供售后服务。
      </li>
      <li>
        <strong>设备信息：</strong
        >我们会收集您使用的设备型号、操作系统版本、唯一设备标识符（如IMEI/Android
        ID/IDFA等）、网络设备地址（MAC）等信息，以保障软件与服务的安全运行、进行bug排查与兼容性分析。
      </li>
      <li>
        <strong>日志信息：</strong
        >当您使用我们的服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括您的<strong>设备信息</strong>、<strong>浏览记录</strong>、<strong>点击记录</strong>、<strong>IP地址</strong>等。
      </li>
    </ul>

    <h2>二、我们如何共享、转让、公开披露您的个人信息</h2>
    <p>我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
    <ul>
      <li><strong>事先获得您明确的同意或授权；</strong></li>
      <li>
        <strong
          >根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下；</strong
        >
      </li>
      <li>
        在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束。
      </li>
      <li>
        为了向您提供更完善的服务，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，为了进行广告投放和效果评估，我们可能需要向广告主及其代理商共享经过匿名化处理的设备信息。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。
      </li>
    </ul>
    <p>
      我们不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。
    </p>

    <h2>三、我们如何存储和保护您的个人信息</h2>
    <p>
      <strong>1. 信息存储的方式和期限：</strong
      >我们会通过安全的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志。一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。在您的个人信息超出保留期限后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。
    </p>
    <p>
      <strong>2. 信息存储的地域：</strong
      >我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。目前我们不会跨境传输或存储您的个人信息。将来如需跨境传输或存储的，我们会向您告知信息出境的目的、接收方、安全保证措施和安全风险，并征得您的同意。
    </p>
    <p>
      <strong>3. 信息安全：</strong
      >我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。
    </p>

    <h2>四、您的权利</h2>
    <p>
      按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
    </p>
    <ul>
      <li>
        <strong>访问权：</strong
        >您有权访问您的个人信息，法律法规规定的例外情况除外。
      </li>
      <li><strong>更正权：</strong>您有权更正或补充您的个人信息。</li>
      <li>
        <strong>删除权：</strong>在特定情形下，您有权要求我们删除您的个人信息。
      </li>
      <li>
        <strong>撤回同意权：</strong
        >您有权通过注销账户、解除绑定、设备设置等方式，撤回我们继续处理您个人信息的授权同意。您撤回同意的决定，不会影响此前基于您的授权而开展的个人信息处理活动的效力。
      </li>
      <li>
        <strong>注销账户：</strong
        >您有权注销您的账户，注销账户后，除法律法规另有规定外，我们将删除或匿名化处理您的个人信息。
      </li>
      <li>
        <strong>账户注销流程：</strong>
        可以通过发送注销申请到【smsmart_zzsm@sina.com】邮箱进行注销，邮件中提供待注销的账号和注销原因即可，我们会在收到邮件后注销您的账户。
      </li>
    </ul>
    <p>如果您想行使上述权利，可以通过本政策第七条提供的方式联系我们。</p>

    <h2>五、我们如何处理未成年人的个人信息</h2>
    <p>
      我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不应创建自己的个人信息主体账户。对于经父母或监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。如果我们发现自己在未事先获得可证实的父母或监护人同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
    </p>

    <h2>六、本政策如何更新</h2>
    <p>
      我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件或站内信形式发送通知，说明隐私政策的具体变更内容）。
    </p>
    <p><strong>本政策所指的重大变更包括但不限于：</strong></p>
    <ul>
      <li>
        我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
      </li>
      <li>
        我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
      </li>
      <li>个人信息共享、转让或公开披露的主要对象发生变化；</li>
      <li>您参与个人信息处理方面的权利及其行使方式发生重大变化；</li>
      <li>
        我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
      </li>
      <li>个人信息安全影响评估报告表明存在高风险时。</li>
    </ul>
    <p>
      <strong
        >若您在本政策更新生效后继续使用我们的服务，即表示您已充分阅读、理解并接受更新后的政策，并同意我们按照更新后的政策收集、使用、存储和共享您的个人信息。</strong
      >
    </p>

    <h2>七、如何联系我们</h2>
    <div class="contact-box">
      <p>
        如果您对本隐私政策有任何疑问、意见、建议，或者需要行使您的个人信息权利、进行投诉举报，请通过以下方式与我们联系：
      </p>
      <p>电子邮件：<strong>smsmart_zzsm@sina.com</strong></p>
      <p>
        一般情况下，我们将在<strong>15个工作日</strong>内受理并处理您的请求。
      </p>
    </div>

    <h2>八、其他说明</h2>
    <div class="contact-box">
      <p>
        我们的产品基于DCloud uni-app(5+
        App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android
        ID/DEVICE_ID/IDFA、SIM 卡 IMSI
        信息、OAID）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。详情内容请访问《[DCloud
        App引擎隐私政策](https://dcloud.io/license/appprivacy.html)》。
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "PingFang SC", "Microsoft YaHei", sans-serif;
  line-height: 1.6;
  color: #333;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
}
.container {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
h1 {
  text-align: center;
  color: #2c3e50;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}
.update-info {
  text-align: center;
  color: #7f8c8d;
  margin-bottom: 30px;
  font-size: 0.9em;
}
h2 {
  color: #3498db;
  margin-top: 30px;
  padding-left: 10px;
  border-left: 4px solid #3498db;
}
p,
li {
  text-align: justify;
}
ul {
  padding-left: 20px;
}
li {
  margin-bottom: 8px;
}
.contact-box {
  background-color: #f1f8ff;
  padding: 20px;
  border-radius: 6px;
  margin-top: 30px;
}
.footer {
  text-align: center;
  margin-top: 40px;
  color: #95a5a6;
  font-size: 0.9em;
}
@media (max-width: 600px) {
  body {
    padding: 10px;
  }
  .container {
    padding: 20px;
  }
}
</style>